import React, { useContext, useEffect, useState } from 'react';
import { isMobile } from '../../../utils/commonUtils';
import PropTypes from 'prop-types';
import '../../../styles/LtsContentView.css';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import {
  getStationCrossDotIntermediate,
  getColorForIntermediateStationAndBelowItFromDotColor
} from '../utils/ltsCardDetailsUtils';

function LtsIntermediateStationContentView({ haltingStation, intermediateStations, parentShowIntermediateCollection }) {
  const [showIntermediateCollection, setShowIntermediateCollection] = useState(parentShowIntermediateCollection);
  const isMobileDevice = isMobile();
  useEffect(() => {
    setShowIntermediateCollection(parentShowIntermediateCollection);
  }, [parentShowIntermediateCollection]);
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  if (!intermediateStations || !intermediateStations.length) {
    return null;
  }

  const { haltingStationCollection, currentStation, trainStartedFromSource, currentIntermediateStation } = {
    ...ltsPageState
  };
  return (
    <React.Fragment>
      {showIntermediateCollection && (
        <ul className={`ltsContentView__inBetweenStation`}>
          {intermediateStations.map((stationDetails, index) => {
            const {
              stationCode,
              stationName,
              distanceFromOriginStation,
              platformNumber,
              stoppingMinutes,
              scheduledArrivalDetails: { scheduledArrivalTime }
            } = stationDetails;
            const stationCrossDotColor = getStationCrossDotIntermediate({
              haltingStation,
              haltingStationCollection,
              currentStation,
              trainStartedFromSource,
              currentIntermediateStation,
              intermediateStationToColor: stationDetails,
              intermediateStations
            });
            return (
              <li key={stationCode}>
                <span className={`${stationCrossDotColor} stationDot `} />
                <span
                  className={`${
                    index === 0 ? 'firstStation' : ''
                  } coloredStationIntermediateSegment ${getColorForIntermediateStationAndBelowItFromDotColor(
                    stationCrossDotColor
                  )}`}
                />
                <div className="makeFlex column stationDistance">
                  <span className={`latoBlack ${!isMobileDevice ? 'font16 appendBottom10' : 'font12 appendBottom5'}`}>
                    {stationCode}
                  </span>
                  <span className="darkGreyText alignSelf--center">{`${Math.round(
                    distanceFromOriginStation
                  )} kms`}</span>
                </div>
                <div className="stationName">
                  <span className={`latoBlack ${!isMobileDevice ? 'font16 appendBottom10' : 'font12 appendBottom5'}`}>
                    {stationName}
                  </span>
                  <span className="darkGreyText">
                    Platform {platformNumber === '0' || !platformNumber ? '--' : `#${platformNumber}`}
                  </span>
                  <div>
                    <span className="railSeoSprite signalIcon appendRight8"></span>
                    <span className="railSeoSprite mealIcon"></span>
                  </div>
                </div>
                {!isMobileDevice && (
                  <span className="platFormWidth darkGreyText">
                    <span className="darkGreyText">
                      Platform {platformNumber === '0' || !platformNumber ? '--' : `#${platformNumber}`}
                    </span>
                  </span>
                )}
                {!isMobileDevice && (
                  <div>
                    <span className="appendRight12 darkGreyText">
                      Stop <span className={'latoBold blackText'}>{stoppingMinutes || '0'}m</span>
                    </span>
                    <span className="railSeoSprite stopWatch"></span>
                  </div>
                )}
                <div className="pushRight">
                  <div className={`${isMobileDevice ? 'makeFlex' : ''}`}>
                    <span className={` latoBold ${!isMobileDevice ? 'appendRight24' : 'appendRight8'}`}>
                      ARR.
                      <br />
                      <span className={`latoBlack ${!isMobileDevice ? 'appendRight24' : 'appendRight8'}`}>
                        {scheduledArrivalTime}
                      </span>
                    </span>
                  </div>
                  {isMobileDevice && (
                    <div>
                      <span className="appendRight12 darkGreyText">
                        Stop <span className={'latoBold blackText'}>{stoppingMinutes || '0'}m</span>
                      </span>
                      <span className="railSeoSprite stopWatch" />
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </React.Fragment>
  );
}

LtsIntermediateStationContentView.propTypes = {
  intermediateStations: PropTypes.array,
  parentShowIntermediateCollection: PropTypes.bool,
  updateParentShowIntermediateCollection: PropTypes.func,
  haltingStation: PropTypes.object
};

export default LtsIntermediateStationContentView;
